<template>
  <div>
    <main-layout>
      <BroadcastMenu />
      <div>
        <div v-if="currentView == 'list'">
          <v-container>
            <template v-if="loading">
              <div class="text-xs-center" style="padding: 10px 0px">
                <scale-loader
                  :color="$vuetify.theme.primary"
                  height="35px"
                  width="7px"
                ></scale-loader>
              </div>
            </template>
            <div v-else>
              <div>
                <h2 class="headline mb-3">{{ $t('Draft') }}</h2>
                <div class="broadcasts">
                  <div style="margin-bottom: 15px">
                    <a
                      href="javascript:void(0);"
                      style="text-decoration: none"
                      @click="
                        selectedEditBroadcast = undefined
                        currentView = 'edit'
                        isSaveOnly = false
                      "
                    >
                      <div class="add-broadcast text-xs-center">
                        <em class="fa fa-plus middle" />
                        {{ $t('Add new broadcast') }}
                      </div>
                    </a>
                  </div>

                  <div
                    id="draft-section"
                    style="
                      background: #ffffff 0% 0% no-repeat padding-box;
                      border-radius: 26px;
                      padding: 20px;
                    "
                  >
                    <BroadcastGroup
                      :title="$t('Draft')"
                      status="draft"
                      @editBroadcast="handleEditBroadcast"
                      @copyBroadcast="handleCopyBroadcast"
                      @viewBroadcast="handleViewBroadcast"
                    />
                  </div>
                </div>
              </div>
              <br />
              <div
                id="approval-section"
                style="
                  background: #ffffff 0% 0% no-repeat padding-box;
                  border-radius: 26px;
                  padding: 20px;
                "
              >
                <BroadcastGroup
                  :title="$t('request_approval')"
                  status="approval"
                  @editBroadcast="handleEditBroadcast"
                  @viewBroadcast="handleViewBroadcast"
                  @onShowBroadcastHistory="handleShowBroadcastHistory($event)"
                />
              </div>
              <br />

              <div
                id="sent-section"
                style="
                  background: #ffffff 0% 0% no-repeat padding-box;
                  border-radius: 26px;
                  padding: 20px;
                "
              >
                <BroadcastGroup
                  :title="$t('Broadcasted')"
                  status="broadcasted"
                  @copyBroadcast="handleCopyBroadcast"
                  @viewBroadcast="handleViewBroadcast"
                  @onShowBroadcastHistory="handleShowBroadcastHistory($event)"
                />
              </div>
            </div>
          </v-container>
          <div class="mt-5 mb-5"></div>
        </div>
        <div v-if="currentView == 'edit'">
          <template v-if="currentView == 'edit'">
            <broadcast-manage
              :value="selectedEditBroadcast"
              :is-save-only="isSaveOnly"
              @onClose="onClose"
              @onSave="onSave"
            ></broadcast-manage>
          </template>
        </div>
        <div v-if="currentView == 'view'">
          <template v-if="selectedViewBroadcast">
            <broadcast-view :value="selectedViewBroadcast" @onClose="onClose"></broadcast-view>
          </template>
        </div>
      </div>
      <DialogBroadcastHistoryVue
        :value="showDialogBroadcastHistory"
        :broadcast="currentBroadcast"
        :type="currentBroadcastLogType"
        @onClose="handleDialogBroadcastHistory"
      />
    </main-layout>
  </div>
</template>

<script>
import mainAiraApi from '@/api/aira.js'
import BroadcastMenu from './BroadcastMenu.vue'
import BroadcastGroup from './BroadcastGroup.vue'
import BroadcastManage from './BroadcastManage'
import BroadcastView from './BroadcastView'
import { mapGetters } from 'vuex'
import { handleResponse, handleApiError } from '@/api/util'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import DialogBroadcastHistoryVue from './DialogBroadcastHistory.vue'

export default {
  components: {
    BroadcastManage,
    BroadcastView,
    BroadcastMenu,
    BroadcastGroup,
    ScaleLoader,
    DialogBroadcastHistoryVue
  },
  data: function () {
    return {
      copy_name: '',
      sent_name: '',
      isSave: false,
      pageloading: false,
      isCopy: false,
      currentView: 'list',
      isFail: false,
      draftBroadcasts: [],
      sentBroadcasts: [],
      scheduleBroadcasts: [],
      approvalBroadcasts: [],
      selectedEditBroadcast: undefined,
      selectedViewBroadcast: undefined,
      loading: false,
      offset: 0,
      limit: 5,
      isSaveOnly: false,
      updateSearchTimeout: null,
      isFetchDraftData: false,
      showDialogBroadcastHistory: false,
      currentBroadcast: undefined,
      currentBroadcastLogType: undefined
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },

  mounted: function () {
    const vm = this

    if (vm.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    vm.$store.dispatch('loadSetting')
  },
  methods: {
    handleDialogBroadcastHistory() {
      this.showDialogBroadcastHistory = false
      this.currentBroadcast = undefined
      this.currentBroadcastLogType = undefined
    },
    handleShowBroadcastHistory({ type, broadcast }) {
      console.log(type, broadcast)
      const vm = this
      vm.currentBroadcast = broadcast
      vm.currentBroadcastLogType = type
      vm.showDialogBroadcastHistory = true
    },
    onClose: function () {
      const vm = this
      vm.currentView = 'list'
    },
    handleEditBroadcast(broadcast) {
      this.editBroadcast(broadcast)
    },
    editBroadcast: function (broadcasts, isSaveOnly = false) {
      const vm = this
      vm.selectedEditBroadcast = broadcasts
      vm.currentView = 'edit'
      vm.isSaveOnly = isSaveOnly
    },
    handleViewBroadcast(broadcast) {
      const vm = this
      vm.selectedViewBroadcast = broadcast
      vm.$nextTick(function () {
        vm.currentView = 'view'
      })
    },
    async saveBroadcast(data) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await mainAiraApi.postSaveBroadcast({
          pageId: vm.selectedBot.pageid,
          data
        })
        vm.$store.commit('CLEAR_LOADING')
        handleResponse(response)

        if (response && response.status === 200) {
          return response
        } else {
          return null
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        handleApiError(error)
        return null
      }
    },
    async onSave(payload) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.saveBroadcast(payload.data)
        vm.$store.commit('CLEAR_LOADING')

        if (response && response.data) {
          const id = response.data.broadcastid
          payload.onSave(true, id)
        } else {
          payload.onSave(false, null)
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        payload.onSave(false, null)
        console.error(error)
      }
    },
    async handleCopyBroadcast(broadcast) {
      this.loading = true
      await this.copyBroadcast(broadcast)
      this.loading = false
    },
    async copyBroadcast(data) {
      const vm = this
      try {
        data.id = null
        data.name += ' copy'
        data.sendflag = false
        data.page_access_token = vm.selectedBot.page_access_token
        vm.copy_name = data.name

        vm.$store.dispatch('loading')
        const response = await vm.saveBroadcast(data)
        vm.$store.commit('CLEAR_LOADING')

        if (response && response.status === 200) {
          vm.$swal.fire({
            title: vm.$t('Broadcast {copy_name} copy', {
              copy_name: data.name.replace(/\<|\>/g, '')
            }),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Aira/Broadcast/Broadcast.vue